// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R6HP","colMin":"styles_colMin__1EiNU"};